import type { RouterState } from './router.type';

import type { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import type { RouterStateSerializer } from '@ngrx/router-store';

export class CustomSerializer implements RouterStateSerializer<RouterState> {
    public serialize(routerState: RouterStateSnapshot): RouterState {
        const { url } = routerState;

        let state: ActivatedRouteSnapshot = routerState.root;
        let params = { ...state.params };
        let queryParams = { ...state.queryParams };

        while (state.firstChild) {
            state = state.firstChild;
            params = { ...params, ...state.params };
            queryParams = { ...queryParams, ...state.queryParams };
        }

        return { url, params, queryParams };
    }
}
